import type React from 'react';

import { Text } from '@change/ds-core-ui';

import { TranslateHtml } from '@change-corgi/core-react/i18n';

export const UpdateHelpText: React.FC = () => {
	return (
		<div className="bg-background-raised mb-4 w-full rounded-lg p-4">
			<Text as="p" size="small" className="wrap-break-word break-keep">
				<TranslateHtml value="fe.pages.petition_update_composer.disclaimer" />
			</Text>
		</div>
	);
};
